import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MsalService} from '@azure/msal-angular';
import {AuthService} from '../../services/auth.service';
import {CommonService} from '../../services/common.service';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {UserService} from '../../services/user.service';
import {AuthDialogComponent} from '../dialogs/auth-dialog/auth-dialog.component';
import {PrivacyDialogComponent} from '../dialogs/privacy-dialog/privacy-dialog.component';
import {environment} from '../../../environments/environment';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, AfterViewInit {

    //#region class members
    public hide: boolean;
    public loginFormGroup: FormGroup;
    changeLoad: boolean;
    imageHeight: number;
    loginFormWidth: number;
    privacyFormWidth: number;
    loading = false;
    return = '';
    productSchoolId: number;
    logoSource = '';
    //#endregion

    //#region constructor and OnInit
    constructor(private route: ActivatedRoute,
                public authService: AuthService,
                public dialog: MatDialog,
                public commonService: CommonService,
                public toastMessagesService: ToastMessagesService,
                public router: Router, private userService: UserService) {
        this.hide = true;
        this.productSchoolId = environment.productSchoolId;
        this.imageHeight = window.innerHeight;
        this.loginFormWidth = window.innerWidth / 4;
        this.privacyFormWidth = window.innerWidth / 4;

        this.loginFormGroup = new FormGroup({
            email: new FormControl('', [Validators.required]),
            password: new FormControl('', Validators.required)
        });

        this.logoSource = environment.productSchoolId === 1 ? '../../../assets/images/haefLogo-1.png' : '../../../assets/images/LoginLogo.png';
        this.logoSource = environment.productSchoolId === 1 ? '../../../assets/images/eapply-logo-1.png' : '../../../assets/images/LoginLogo.png';
        // this.logoSource = environment.productSchoolId === 1 ? '../../../assets/images/haefLogo.png' : '../../../assets/images/LoginLogo.png';

        this.changeLoad = false;
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(async (params) => {
                this.return = params.return || 'home';
                this.commonService = params.return;
                if (this.userService.isValid()) {
                    await this.router.navigateByUrl(this.return);
                }
            });
    }

    ngAfterViewInit() {
    }

    //#endregion

    //#region async functions
    async onLogin() {
        try {
            this.loading = true;
            const response = await this.authService.login(this.loginFormGroup.controls.email.value, this.loginFormGroup.controls.password.value);
            if (response.status === 200) {
                localStorage.setItem('user', JSON.stringify(response.object.currentUser));
                localStorage.setItem('token', response.object.token);
                await this.router.navigateByUrl(this.return);
            } else {
                this.toastMessagesService.toastMessages('Τα στοιχεία που πληκτρολογήσατε δεν είναι σωστά ή δεν σας επιτρέπεται η πρόσβαση από το αυστηρό εταιρικό σας firewall.');
            }
        } catch (e) {
            this.toastMessagesService.toastMessages(`${e.message}`);
        } finally {
            this.loading = false;
        }
    }

    //#endregion


    //////////////////////////////////////
    // Display
    showStep(id: string) {
        const authStepDialog = this.dialog.open(AuthDialogComponent, {
            data: {
                userId: id
            }
        });

        authStepDialog.afterClosed().subscribe(async (authMessage) => {
            if (authMessage) {
                if (authMessage.message === 'OK') {
                    if (authMessage.token) {
                        localStorage.setItem('token', authMessage.token);
                    }
                    await this.router.navigate(['home']);
                } else {
                    console.log('wrong number');
                }
            }
        });
    }

    showTermsOfUse() {
        this.dialog.open(PrivacyDialogComponent, {
            width: '800px',
            height: '600px'
        });
    }

    async keyDownFunction($event: KeyboardEvent) {
        if ($event.keyCode === 13) {
            await this.onLogin();
        }
    }

    async navigateToRegistration() {
        await this.router.navigate(['registration']);
    }

    inviteParent() {

    }
}
